import { KEYS } from "../utils/constants";
import { isPlatform } from '@ionic/react';

interface EndPoints {
  [index: string]: any;
  HOME: Keys;
}
interface Keys {
  [index: string]: string;
  RECOMMENDED_LOADS: string;
}

const carrierMemberUrl = "/carriermember/v1/member";
const platform = (isPlatform('android') || isPlatform('ios')) ? '/mobile' : '/web';
export const URL_ENDPOINTS: EndPoints = {
  HOME: {
    RECOMMENDED_LOADS: platform + "/v1/experience",
    SIMILAR_LOADS: platform + "/v1/experience",
    DETAILED_LOADS: platform + "/v1/experience",
  },
  SEARCH: {
    SEARCH: "/web/v1/experience",
    SEARCH_STOF: "/load/v2/loadposting",
  },
  RECENT: {
    RECENT: "/usersearch/v1/history",
  },
  FAVORITE: {
    FAVORITE_LOADS: "/usersearch/v1/history",
  },
  DRIVERS_LIST: {
    DRIVERS_LIST: platform + "/v1/experience",
  },
  FETCH_USER_DETAILS: {
    USER_DETAILS: carrierMemberUrl,
    EXP_GET_MEMBER: platform + "/v1/experience",
    GET_USER_DETAILS: carrierMemberUrl,
    RESEND_INVITE_NOTIFICATION : platform + "/v1/resendinvitation",
  },
  FETCH_USER_DETAILS_NEW: {
    GET_USER_DETAILS_NEW: platform + "/v1/experience",
    USER_DETAILS_NEW: carrierMemberUrl,
  },
  MYLOAD: {
    CARRIER: "/v1/shipment",
    CARRIER_WITH_EXPERIENCE: platform+"/v1/experience",
    BUY_LOAD: "/load/v2/loadposting",
    CONTACT_US : platform+"/v1/contact/shipment/{shipmentId}",
  },
  MANAGE: {
    MY_CAPACITY: "/laneandtruck/v1/laneandtruck",
    CARRIER_PROFILE: "/masterdata/v1/carrierdata",
  },
  LOCATION_TRACKER: {
    LOCATION_TRACKER: "/devicelocation/v1/location",
  },
  REGISTER_DEVICE: {
    REGISTER_DEVICE: "/devicemanage/v1/manage",
  },
  MORETAB: {
    MORETAB: "/contentstack/v1/contentstack",
  },
  CONFIG: {
    APP_LEVEL: "/contentstack/v1/content-stack/config?env={configEnv}",
  },
  SUBMITFEEDBACK: {
    SUBMITFEEDBACK: "/devicemanage/v1/manage",
  },
  AZURE_MAPS: {
    ACCESS_TOKEN: "/zipcode/v1/oauth2/token",
  },
  COUNTRY_CODES: {
    COUNTRY_CODES: "/load/v2/getSearchScreenDefaults",
  },
  NOTIFICATION_SERVICES: {
    GET_NOTIFICATION:
      "/v1/retrievebystatusandupn?notificationStatus=UNREAD&UPN={upn}",
    UPDATE_DELETE_NOTIFICATION: "/v1/{vendorMessageID}",
    UPDATE_NEW_TO_UNREAD_NOTIFICATION: "/v1",
  },
  CARRIER_INTENT: {
    CARRIER_INTENT: "/intent/v1/publishCarrierIntent"
  },
  FEEDBACK: {
    FEEDBACK: "/user/events/v1/publishUserEvent"
  },
  USER: {
    DELETE: platform + "/v1/experience",
  },
  DOCUMENT:{
    DOCUMENTLIST : platform+"/v1/experience",
    FETCHDOCUMENT : platform+"/v1/experience",
    UPLOADDOCUMENT: platform+"/v1/experience",
    UPLOAD_DOCUMENT_NEW: platform+"/v2/submitDocumentV2",
    SUBMIT_INVOICE_NEW: platform+"/v2/uploadInvoiceV2",
  },
  EXPERIENCE: {
    CONTENTORCONFIG: platform + "/v1/contentorconfig",
    TERMS_AND_CONDITION: platform + "/v1/contentorconfig?contentType=terms_and_conditions",
    GET_PREFERENCE: platform+"/v1/experience",
    POST_PREFERENCE: platform+"/v1/experience",
    NUMBER_VALIDATION: platform+"/v1/experience",
    PCMILLER: platform+"/v1/api/locations/searchByQuery?query={query}",
  }

};

/**
 * To build request URL with provided inputs.
 * @param {string} endPoint URL category name.
 * @param {string} urlKey endpoint key name.
 * @param {*} value query string value to append to the url.
 */

export default function getURLDetails(
  endPoint: string,
  urlKey: string,
  value?: any
) {
  return {
    get_Service_Url: function () {
      let _url = "";
      const keyValue = URL_ENDPOINTS[endPoint][urlKey];
      const API_HOST = endPoint !== "NOTIFICATION_SERVICES"
        ? KEYS.API_HOST
        : KEYS.NOTIFICATION_API_HOST
      if (keyValue) {
        _url = `https://${API_HOST}${keyValue}`;
        _url = value
          ? _url
            .replace("{upn}", value)
            .replace("{configEnv}", value)
            .replace("{vendorMessageID}", value)
            .replace("{shipmentId}",value)
            .replace("{query}",value)
          : _url;
      } else {
        throw new Error(
          "key value of End point URL is not matching with provided key name."
        );
      }
      return _url;
    },
  };
}